export default __webpack_public_path__ + "static/media/img2.4b2f67ae.jpg";